<script>
  import tipoUsuario from '~js/tipo-usuario';
  import webPessoaServico from '~modulos/web-pessoa/servico';
  import Carregando from '~componentes/Carregando.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import DadosBancarios from './compartilhado/FormDadosBancarios.vue';
  
  export default {
    components: { Carregando, DadosCadastrais, AdicionarArquivos, ListaDeArquivos, DadosBancarios },
    data() {
      return {
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
        tipoUsuario: tipoUsuario,
        senhaCriada: this.$storage.senhaCriada() || '',
        carregando: true,
        arquivos: [],
        pessoa: {
          nomePessoaFisicaJuridica: '',
          dataNascimento: '',
          identidadeinscestadual: '',
          inss: '',
          pisPasep: '',
          endereco: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: '',
          cpfCnpj: '',
          telefone1: '',
          telefone2: '',
          fax: '',
          email: '',
          tipoPessoaFisicaJuridica: '',

          nomeFantasia: '',
          carteiraTrabalhoInscMunicipal: '',
          contato: '',
          cargoFinanceiro: '',
          telContatoFinanceiro: '',
          contatoCompras: '',
          cargoCompras: '',
          telContatoCompras: '',
          emailCompras: '',
          emailPesquisa: '',
          dataAlteracaoAcessoWeb: '',
          webDadosBancarios: [],
          webSocios: [],
          webCertidoes: [],
          webAtividades: [],
        },
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Alterar cadastro WEB';

      this.$root.botaoAcaoMostrar = false;
      
      this.carregar();
    },
    methods: {
      salvar() {
        $('#salvar').button('loading');

        if (this.usuario.tipoUsuario === this.tipoUsuario.PessoaFisicaWeb) {
          this.$refs.dadosCadastrais
            .validar()
            .then(this.enviar)
            .then(dados => {
              $('#salvar').button('reset');

              toastr.success(`Dados alterados com sucesso.`);

              if ('pessoa' in dados) {
                this.pessoa = dados.pessoa;
                this.pessoa = this.normalizarParaVisualizar(this.pessoa);
                this.usuario = dados.usuario;
                this.senhaCriada = dados.senhaCriada;

                this.$storage.usuario(dados.usuario);
                this.$storage.senhaCriada(dados.senhaCriada);
              } else {
                this.pessoa = dados;
                this.pessoa = this.normalizarParaVisualizar(dados);
              }

              if ('arquivos' in dados) {
                this.arquivos = dados.arquivos;
              }

              this.$refs.adicionarArquivos.limparArquivos();
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            })
            .catch(erro => {
              $('#salvar').button('reset');

              this.$mensagemErro(erro);
            })
        } else {
          this.$refs.dadosCadastrais
            .validar()
            .then(this.enviar)
            .then(dados => {
              $('#salvar').button('reset');

              toastr.success(`Dados alterados com sucesso.`);

              if ('pessoa' in dados) {
                this.pessoa = dados.pessoa;
                this.pessoa = this.normalizarParaVisualizar(this.pessoa);
                this.usuario = dados.usuario;
                this.senhaCriada = dados.senhaCriada;

                this.$storage.usuario(dados.usuario);
                this.$storage.senhaCriada(dados.senhaCriada);

                
              } else {
                this.pessoa = dados;
                this.pessoa = this.normalizarParaVisualizar(dados);
              }

              if ('arquivos' in dados) {
                this.arquivos = dados.arquivos;
              }

              this.$refs.adicionarArquivos.limparArquivos();
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            })
            .catch(erro => {
              $('#salvar').button('reset');

              this.$mensagemErro(erro);
            });
        }
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        return (this.usuario.tipoUsuario === this.tipoUsuario.PessoaFisicaWeb)
          ? this.alterar() : this.cadastrar();   
      },
      cadastrar() {
        const arquivos = this.$refs.adicionarArquivos.arquivos;
        return webPessoaServico.cadastrarPessoa(this.pessoa,arquivos);
      },
      alterar() {
        this.$set(this.pessoa, 'arquivosDeletados', this.$refs.listaArquivos.deletados)
        const arquivos = this.$refs.adicionarArquivos.arquivos;

        return webPessoaServico.alterarPessoa(this.pessoa, arquivos);
      },
      download(arquivo) {
        webPessoaServico
          .download(this.pessoa.idPessoaFisicaJuridica, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
      normalizarParaVisualizar(pessoa) {
        if (pessoa.inss) {
          pessoa.inss = pessoa.inss.replace('   .     .  / ', "");
        }

        if (pessoa.pispasep) {
          pessoa.pispasep = pessoa.pispasep.replace('   .     .  / ', "");
        }

        if (pessoa.dataNascimento) {
          pessoa.dataNascimento = this.$options.filters.formatarNumeroEmData(pessoa.dataNascimento);
        }        

        return pessoa;
      },
      carregar() {
        this.carregando = true;

        if (this.usuario.tipoUsuario === this.tipoUsuario.PessoaFisicaWeb) {
          return webPessoaServico
            .pessoa()
            .then(dados => {
              this.pessoa = this.normalizarParaVisualizar(dados);
            })
            .then(() => webPessoaServico.arquivos(this.pessoa.idPessoaFisicaJuridica))
            .then(arquivos => {
              this.arquivos = arquivos;
            })
            .then(() => {
              this.carregando = false;
            });
        } else {
          this.pessoa.cpfCnpj = this.usuario.documento;
          this.pessoa.tipoPessoaFisicaJuridica = this.usuario.documento.length <= 14 ? 1 : 2;

          this.carregando = false;
          return;
        }
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="">

      <carregando v-if="carregando"></carregando>

      <div v-if="senhaCriada.length > 0">
        <h2><b>Sua senha é: {{senhaCriada}}</b></h2>
        <p><b>Por favor anote-a para realizar futuros acessos!</b></p>
      </div>

      <div class="tabs-container" v-show="!carregando" id="tabs">

        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab"
               href="#tab-dados-cadastrais">
              Dados cadastrais
            </a>
          </li>

          <li>
            <a data-toggle="tab"
               href="#tab-dados-bancarios">
              Dados bancários
            </a>
          </li>

          <li>
            <a data-toggle="tab"
               href="#tab-adicionar-arquivos">
              Adicionar arquivos
            </a>
          </li>
          <li v-if="(usuario.tipoUsuario === tipoUsuario.PessoaFisicaWeb)">
            <a data-toggle="tab"
               href="#tab-arquivos">
              Arquivos
            </a>
          </li>
        </ul>

        <div class="tab-content">
          <div id="tab-dados-cadastrais" class="tab-pane active">
            <div class="panel-body">
              <dados-cadastrais ref="dadosCadastrais"
                                :pessoa="pessoa"
                                :carregando="carregando">
              </dados-cadastrais>
            </div>
          </div>

          <div id="tab-dados-bancarios" class="tab-pane">
            <div class="panel-body">
              <dados-bancarios ref="dadosBancarios"
                               :dadosBancarios="pessoa.webDadosBancarios">
              </dados-bancarios>
            </div>
          </div>

          <div id="tab-adicionar-arquivos" class="tab-pane">
            <div class="panel-body">
              <adicionar-arquivos ref="adicionarArquivos">
              </adicionar-arquivos>
            </div>
          </div>

          <div id="tab-arquivos" class="tab-pane">
            <div class="panel-body">
              <lista-de-arquivos :arquivos="arquivos"
                                 @download="download"
                                 ref="listaArquivos">
              </lista-de-arquivos>
            </div>
          </div>
        </div>

      </div>

      <div class="row" v-show="!carregando">
        <div class="col-xs-9">
          <div class="form-group">
            <router-link
              class="btn btn-default"
              :to="{ name: 'home' }"
              active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button
              id="salvar"
              type="button"
              class="btn btn-primary"
              @click="salvar"
              data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
        <div class="col-xs-9">
          <span class="time-right" v-if="pessoa.dataAlteracaoAcessoWeb">
            Última atualização realizada em {{pessoa.dataAlteracaoAcessoWeb | formatarData }} às {{pessoa.dataAlteracaoAcessoWeb | formatarHora }}
          </span>
        </div>
      </div>
      
    </form>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-pessoa-fisica/componentes/Alterar.vue